<!-- QR Modal (Figma -> Angular template) -->
<div class="qr-modal-overlay" role="dialog" aria-modal="true">
	<div class="qr-modal">
		<header class="qr-modal__header">
			<h4 class="qr-modal__label">Receive</h4>
			<button class="qr-modal__close" aria-label="Close" (click)="onClose()">
				<img src="assets/icons/close-gray.png" alt="close">
			</button>
		</header>

		<div class="qr-modal__card">
			<div class="qr-modal__body">
				<h3 class="qr-modal__title">Your QR Code</h3>

				<div class="qr-modal__qr-wrap">
					<img class="qr-modal__qr" [src]="qrSrc" alt="QR code" />
				</div>

				<div class="qr-modal__user">
					<div class="qr-modal__name">{{ name }}</div>
					<div class="qr-modal__contact">
						<span class="qr-modal__phone">{{ phone }}</span>
						<span class="qr-modal__sep" aria-hidden="true"></span>
						<span class="qr-modal__email">{{ email }}</span>
					</div>
				</div>
			</div>
		</div>

		<footer class="qr-modal__footer">
			<button class="btn btn--ghost" (click)="onShare()">Share</button>
			<button class="btn btn--ghost" (click)="onDownload()">Download QR code</button>
		</footer>
	</div>
</div>